import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper/dist/vue-awesome-swiper.esm';
import IconArrow from '@vip-activity/ui/components/icon/IconArrow.vue';
import RankService from '@/service/rank';
import { STATUS } from './constant';
import setting from '../Rank/setting';

var LightEdit = function LightEdit() {
  return import('../LightEdit/LightEdit.vue');
};

var HuoMask = function HuoMask() {
  return import('../HuoMask/HuoMask.vue');
};

var defaultLights = [{
  content: setting.灯牌默认文案,
  rank: 0
}];
export default {
  name: '',
  data: function data() {
    return {
      showLightEdit: false,
      lights: defaultLights,
      myLightData: null,
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: true,
        touchRatio: 1.5,
        speed: 1000 // config参数同swiper4,与官网一致

      }
    };
  },
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide,
    IconArrow: IconArrow,
    LightEdit: LightEdit,
    HuoMask: HuoMask
  },
  computed: {
    myLightBtn: function myLightBtn() {
      if (this.isLiveEnd) return '查看我的灯牌';

      if (this.myLightData) {
        // 已发送审核
        if (this.myLightData.is_send_check) {
          if (this.myLightData.check_status === STATUS.CHECKING) {
            return '【审核中】我的灯牌';
          }

          if (this.myLightData.check_status === STATUS.CHECK_SUCCESS) {
            return '【审核通过】我的灯牌';
          }

          if (this.myLightData.check_status === STATUS.CHECK_FAIL) {
            return '【审核失败】我的灯牌';
          }
        }
      }

      return '编辑我的灯牌';
    }
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      this.getLight();
      this.getMyLight();
    },
    getLight: function getLight() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _res$comment_list_inf, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return RankService.getLight();

              case 3:
                res = _context.sent;

                if ((_res$comment_list_inf = res.comment_list_info) === null || _res$comment_list_inf === void 0 ? void 0 : _res$comment_list_inf.length) {
                  _this.lights = res.comment_list_info;
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error('err: ', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    getMyLight: function getMyLight() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return RankService.getMyLight();

              case 3:
                res = _context2.sent;
                _this2.myLightData = res.user_content_info;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('err: ', _context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    openLightEdit: function openLightEdit() {
      if (this.loginService.isLogin) {
        this.toggelLightEdit(true);
      } else {
        this.loginService.openLogin();
      }
    },
    toggelLightEdit: function toggelLightEdit(type) {
      this.showLightEdit = type;
    }
  }
};